import { FC, useCallback } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { RefreshCw } from 'lucide-react';

import { cn } from '@/lib/utils';

interface CustomersHeaderProps {
  className?: string;
  isFetching: boolean;
  formatedUpdatedAt: string;
  refetchCustomers: () => Promise<void>;
}

export const CustomersHeader: FC<CustomersHeaderProps> = ({
  className,
  isFetching,
  formatedUpdatedAt,
  refetchCustomers,
}: CustomersHeaderProps) => {
  const { t } = useTranslation();

  const refresh = useCallback(async () => {
    if (isFetching) return;
    await refetchCustomers();
  }, [refetchCustomers, isFetching]);

  return (
    <div className={cn('page-top-container', className)}>
      <span className='page-top-title'>{t('customers.navTitle')}</span>
      <div className='flex items-center gap-2 justify-end'>
        <span className='page-top-title'>
          <Trans
            i18nKey='customers.lastUpdated'
            values={{ time: formatedUpdatedAt }}
          />
        </span>
        <RefreshCw
          aria-disabled={isFetching}
          aria-label={t('common.refresh')}
          size='icon-sm'
          className={cn(
            'size-3.5 cursor-pointer',
            isFetching
              ? 'animate-spin'
              : 'transition-transform duration-300 hover:rotate-180'
          )}
          onClick={refresh}
        />
      </div>
    </div>
  );
};
